// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BEAttribute } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
/**
 * 实体属性列表DTO DTO类
 * 实体属性列表DTO，包括属性列表及关联属性列表
 */
export class EntityAttributesDTO {
  /** 属性集合 : 属性集合 */
  private _attributes: Array<BEAttribute>;

  /** 设置：属性集合 */
  public get attributes() {
    return this._attributes;
  }

  /** 获取：属性集合 */
  public set attributes(value: Array<BEAttribute>) {
    this._attributes = value;
  }

  constructor() {
    this._attributes = new Array<BEAttribute>();
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    json.Attributes.forEach((element: any) => this.attributes.push(BEAttribute.Create(element)));
  }

  protected Serialize(json: any): void {
    this.attributes.forEach((element) => json.Attributes.push(element.toJson()));
  }

  static Create(json: any): EntityAttributesDTO {
    const entityAttributesDTO = new EntityAttributesDTO();
    entityAttributesDTO.Deserialize(json);
    return entityAttributesDTO;
  }
}
